import { render } from "./InstagramSvg.vue?vue&type=template&id=1de5ee6b"
import script from "./InstagramSvg.vue?vue&type=script&lang=js"
export * from "./InstagramSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__